import { ChevronLeftIcon } from '@chakra-ui/icons'
import { HStack, Text } from '@chakra-ui/react'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router-dom'
import routes from 'routes'

const OrganizationDetailPageHeader = () => {
  const { organizationStore } = useStores()
  const { organization } = organizationStore
  const navigate = useNavigate()

  return (
    <HStack as="span" spacing={2}>
      <ChevronLeftIcon cursor="pointer" onClick={() => navigate(routes.report.organization.value)} />
      <Text as="span">{organization?.name}</Text>
    </HStack>
  )
}

export default observer(OrganizationDetailPageHeader)
